import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const AutomationSelect = ({ automations = [], value, onChange, disabled = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (!automations.length) {
    return null;
  }

  const selected =
    automations.find((item) => String(item.id) === String(value)) ?? automations[0];

  const handleSelect = (automationId) => {
    onChange(automationId);
    setIsOpen(false);
  };

  return (
    <div ref={containerRef} className="relative">
      <button
        type="button"
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled || automations.length <= 1}
        className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-200 rounded-lg hover:border-gray-300 transition-colors shadow-sm disabled:opacity-60 disabled:cursor-default"
      >
        <span className="text-sm font-medium text-gray-700 max-w-[240px] truncate">
          {selected?.workflow_name ?? `Automation #${selected?.id}`}
        </span>
        {automations.length > 1 && (
          <ChevronDown
            size={16}
            className={`text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          />
        )}
      </button>

      {isOpen && automations.length > 1 && (
        <div className="absolute left-0 top-full mt-2 bg-white border border-gray-200 rounded-xl shadow-xl z-[1100] py-1 min-w-[280px] max-h-[320px] overflow-y-auto">
          {automations.map((automation) => {
            const isSelected = String(automation.id) === String(value);
            return (
              <button
                key={automation.id}
                type="button"
                onClick={() => handleSelect(automation.id)}
                className={`w-full text-left px-4 py-2.5 text-sm transition-colors ${
                  isSelected
                    ? 'bg-primary/10 text-primary font-medium'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {automation.workflow_name ?? `Automation #${automation.id}`}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AutomationSelect;
